(function () {
  angular.module("akitabox.workOrder", [
    "ui.router",
    "akitabox.constants",
    "akitabox.core.constants",
    "akitabox.core.router",
    "akitabox.core.services.flag",
    "akitabox.workOrder.buildingList",
    "akitabox.workOrder.create",
    "akitabox.workOrder.detail",
    "akitabox.ui.dialogs.message.create",
    "akitabox.ui.dialogs.displayText",
    "akitabox.workOrder.myList",
  ]);
})();
